import { render, staticRenderFns } from "./previewImage.vue?vue&type=template&id=62439ad9&"
import script from "./previewImage.vue?vue&type=script&lang=ts&"
export * from "./previewImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports